module.exports = __webpack_public_path__ + "static/media/leftHand.f2c5eaf7.svg";